import * as React from 'react';
import * as identity from '../../utilities/identity';
import StandardLayout from '../layouts/StandardLayout';
import Form from '../common/form/Form';
import FormInput from '../common/form/Input';
import { browserHistory } from '../../utilities/history';
import * as authApi from '../../api/Auth';
import LoadingOverlay from './LoadingOverlay';
import { ApiResult } from '../../api/Shared';
import { SetPasswordInfo } from '../../api/Auth';

interface State {
    username: string;
    password: string;
    confirmPassword: string;
    errorMessage?: string;
    wasFormValidated: boolean;
    isLoading: boolean;
}

interface Props {
    token: string;
    username: string;
    setPassword: (passwordSet: SetPasswordInfo) => Promise<ApiResult<undefined>>;
    title: string;
}

class SetPasswordForm extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            username: this.props.username,
            password: '',
            confirmPassword: '',
            wasFormValidated: false,
            isLoading: false
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentWillMount() {
        // users are logged out before taking any password set action
        identity.clearToken();
    }

    render() {
        return (
            <div>
                <LoadingOverlay show={this.state.isLoading} inBootstrapColumn={false} />
                <StandardLayout>
                    <Form
                        wasFormValidated={this.state.wasFormValidated}
                        inBootstrapColumn={false}
                        submitButtonText="Submit"
                        errorMessage={this.state.errorMessage}
                        onSubmit={this.handleSubmit}
                        onFormValidated={() => this.handleInputChange('wasFormValidated', true)}
                        divClassname="content container col col-md-8 col-lg-6 col-xl-4"
                    >
                        <h2 className="text-center">{this.props.title}</h2>
                        <FormInput
                            inputProps={{
                                id: 'username',
                                name: 'username',
                                type: 'username',
                                value: this.state.username,
                                required: true
                            }}
                            labelProps={{
                                labelText: 'Username'
                            }}
                            onChange={this.handleInputChange}
                        />
                        <FormInput
                            inputProps={{
                                id: 'password',
                                name: 'password',
                                type: 'password',
                                value: this.state.password,
                                required: true,
                                minLength: 12
                            }}
                            labelProps={{
                                labelText: 'Create a new password',
                                invalidText: 'Please enter a password at least 12 characters long'
                            }}
                            onChange={this.handleInputChange}
                        />
                        <FormInput
                            inputProps={{
                                id: 'confirm-password',
                                name: 'confirmPassword',
                                type: 'password',
                                value: this.state.confirmPassword,
                                required: true,
                                minLength: 12
                            }}
                            labelProps={{
                                labelText: 'Confirm your password',
                                invalidText: 'Please enter the same password as above'
                            }}
                            onChange={this.handleInputChange}
                        />
                    </Form>
                </StandardLayout>
            </div>
        );
    }

    private handleInputChange(valueName: string, newValue: string | boolean | number) {
        this.setState({
            ...this.state,
            [valueName]: newValue,
            errorMessage: undefined
        });
    }

    private async handleSubmit() {
        if (this.state.password !== this.state.confirmPassword) {
            this.setState({
                errorMessage: 'Please enter the same password in both fields'
            });
            return;
        }
        this.setState({
            isLoading: true
        });

        var registerResult = await this.props.setPassword({
            username: this.state.username,
            password: this.state.password,
            token: this.props.token
        });

        if (!registerResult.success) {
            if (registerResult.error) {
                this.setState({
                    errorMessage: registerResult.error,
                    isLoading: false
                });
            }
            return;
        }
        let loginResult = await authApi.logIn(this.state.username, this.state.password);

        if (loginResult.success) {
            identity.setTokens(loginResult.data!.jwt, loginResult.data!.refreshToken);
            browserHistory.push('/admin/prospects');
        } else {
            this.setState({
                password: '',
                errorMessage: loginResult.error
            });
        }
    }
}

export default SetPasswordForm;



// WEBPACK FOOTER //
// ./src/components/common/SetPasswordForm.tsx